<template>
    <div>
        <div class="breadcrumbs overlay">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-8 offset-lg-2 col-md-12 col-12">
                        <div class="breadcrumbs-content">
                            <h1 class="page-title">African Investment Summit</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-details detail-section">
            <div class="container">
                <div class="row">

                    <div class="col-12">
                        <div class="details-content">
                            <div class="text">
                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <p>
                                        It’s a recurrent program we hold to discuss innovations in Africa,
                                        opportunities, and as well introduce individuals accross the globe to our
                                        opportunities provided at Tribinnov Africa.
                                        Want to get informed of the next one?
                                    </p>
                                </div>
                                <div class="button my-5" style="text-align: center;">
                                    <a href="#" target="_blank" class="btn">Sign Up Here <i
                                            class="lni lni-arrow-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InvestmentSummit',
        metaInfo: {
            title: "Tribinnov Africa - Africa Investment Summit",
            meta: [
                { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
            ]
        }
    }
</script>